import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import store from "@/store";
// import {clearLocal, checkToken} from "@Assets/utils";

// create an axios instance
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  // baseURL: '/internet',
  baseURL: '/internet',
  timeout: 60000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    // const token = checkToken() || "";
    // if (token) {
    //   config.headers["Authorization"] = "Bearer " + token;
    //   config.headers["Content-Type"] = "application/json";
    // }
    return config;
  },
  (error) => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;
    if (!response.request.responseType) {
      if (res.code !== 200) {
        Message({
          message: res.msg || "网络异常！",
          type: "error",
        });
        return Promise.reject(new Error(res.msg || "Error"));
      }
      return res;
    }
    return response;
  },
  (error) => {
    console.log(error, 666666)

    // if (error.response.status === 401) {
    //   clearLocal();
    //   store.dispatch("clearUserInfo");
    //   router.push("/login");
    //   Message({
    //     message: error.response.data.msg,
    //     type: "error",
    //   });
    // } else {
    //   Message({
    //     message: error.message,
    //     type: "error",
    //   });
    // }
    return Promise.reject(error);
  }
);

export default service;
